// Scrolls the menu item with the given data-menu-url to the center of its container.
// Does nothing if the item isn't there, e.g. filtered out.
export const scrollMenuItemIntoView = (
  container: HTMLElement | null,
  url: string | null
): void => {
  if (!container || !url) {
    return;
  }

  const item = container.querySelector<HTMLElement>(
    `[data-menu-url="${CSS.escape(url)}"]`
  );
  item?.scrollIntoView({ block: 'center' });
};
